/*
* 登录日志管理组件
*/

import { Component } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Input,
} from 'antd';
import {
    UjoinParams,
    AddRequestHeaders,
    isGTscreenWidth,
} from '../../incs/FunHelper.js';

const Lists = (props) => {
    const columns = [
        { title: '', dataIndex: '', key: 'key', fixed: 'left', width: CNF.searchMarginLeft * 4, },
        { title: '账户', dataIndex: 'account', key: 'account', fixed: 'left', },
        { title: '远程地址', dataIndex: 'remote_ip', key: 'remote_ip', },
        { title: '主机', dataIndex: 'host', key: 'host', },
        // {title: 'user_agent', dataIndex: 'user_agent', key: 'user_agent', },
        { title: '状态码', dataIndex: 'login_res', key: 'login_res', },
        { title: '状态消息', dataIndex: 'login_msg', key: 'login_msg', },
        { title: '授权码', dataIndex: 'authorization_code', key: 'authorization_code', },
        { title: '登录时间', dataIndex: 'create_time', key: 'create_time', sorter: (a, b) => Date.parse(a.create_time) - Date.parse(b.create_time), width: CNF.tableCreateTimeColumnWidth + 60 },
    ];
    return (
        <div>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                scroll={{ x: props.x }}
                showSorterTooltip={{ target: 'sorter-icon' }}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => `共${props.pageCount}条`,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </div>
    );
}

class CPT extends Component {
    constructor(props) {
        super(props);
        this.state = {
            init: 0,
            isRefresh: 0,
            currentIndex: 1,
            pageCount: 0,
            dataLists: [],
            account: '',
            remoteIP: ''
        }
    }

    isRefresh = () => { this.setState({ isRefresh: this.state.isRefresh === 1 ? 0 : 1 }); }
    search = () => { this.setState({ currentIndex: 1 }); this.isRefresh(); }
    changeAccount = (e) => { this.setState({ account: e.target.value }); this.search(); }
    changeRemoteIP = (e) => { this.setState({ remoteIP: e.target.value }); this.search(); }
    changeIndex = (index) => { this.setState({ currentIndex: index }); this.isRefresh(); }

    /**
     * 获取操作日志列表
     */
    getLists() {
        const _this = this;
        const params = {
            'account': this.state.account,
            'remote_ip': this.state.remoteIP,
            'page_size': isGTscreenWidth ? CNF.pageSize : CNF.pageSize - 2,
            'current_index': this.state.currentIndex
        };
        $.ajax({
            url: `${CNF.api}log/logins${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            crossDomain: true,
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        _this.setState({
                            dataLists: data.dat,
                            pageCount: data.cnt
                        });
                    } else {
                        _this.setState({
                            dataLists: [],
                            pageCount: 0
                        });
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    componentDidUpdate() {
        if (this.state.init !== this.state.isRefresh) {
            this.getLists();
            this.setState({
                init: this.state.isRefresh
            });
        }
    }

    componentDidMount() {
        this.getLists();
    }

    render() {
        return (
            <>
                <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                    <Col span={isGTscreenWidth ? 3 : 4}>
                        <Input
                            onChange={this.changeAccount}
                            placeholder='登录账户'
                            value={this.state.account}
                        />
                    </Col>
                    <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: 5 }}>
                        <Input
                            onChange={this.changeRemoteIP}
                            placeholder='远程地址'
                            value={this.state.remoteIP}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Lists
                            dataLists={this.state.dataLists}
                            currentIndex={this.state.currentIndex}
                            pageCount={this.state.pageCount}
                            changeIndex={this.changeIndex}
                            isRefresh={this.isRefresh}
                        />
                    </Col>
                </Row>
            </>
        );
    }
}

export default CPT